import React from 'react';
import { motion } from 'framer-motion';
import { FaGithub, FaLinkedin, FaInstagram, FaHeart, FaFlask } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    { icon: FaGithub, href: 'https://github.com/jitenmahajan', label: 'GitHub' },
    { icon: FaLinkedin, href: 'https://www.linkedin.com/in/jiten-mahajan-2246351aa?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app', label: 'LinkedIn' },
    { icon: FaInstagram, href: 'https://instagram.com/jiten.eth', label: 'Instagram' },
  ];

  const quickLinks = [
    { name: 'Home', href: '#home' },
    { name: 'About', href: '#about' },
    { name: 'Skills', href: '#skills' },
    { name: 'Projects', href: '#projects' },
    { name: 'Experience', href: '#experience' },
    { name: 'Contact', href: '#contact' },
  ];

  return (
    <footer className="bg-gray-900 border-t border-green-900 py-12 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <motion.div
              className="flex items-center gap-2 mb-4"
              whileHover={{ scale: 1.05 }}
            >
              <div className="w-12 h-12 bg-bb-green border-2 border-bb-green-light flex items-center justify-center">
                <span className="text-white font-bold text-xl">JM</span>
              </div>
              <div>
                <span className="text-white font-bold text-lg">Jiten Mahajan</span>
                <p className="text-gray-500 text-xs">Heisenberg of Code</p>
              </div>
            </motion.div>
            <p className="text-gray-400 text-sm mb-4">
              Cooking clean code since 2019.
              Specializing in React, Node.js, and turning caffeine into applications.
            </p>
            <div className="flex gap-4">
              {socialLinks.map((social) => (
                <motion.a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-bb-green-light transition-colors"
                  whileHover={{ scale: 1.2, y: -2 }}
                >
                  <social.icon size={20} />
                </motion.a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold mb-4 flex items-center gap-2">
              <FaFlask className="text-bb-green-light" />
              Quick Links
            </h4>
            <div className="grid grid-cols-2 gap-2">
              {quickLinks.map((link) => (
                <motion.a
                  key={link.name}
                  href={link.href}
                  className="text-gray-400 hover:text-bb-green-light transition-colors text-sm"
                  whileHover={{ x: 5 }}
                >
                  → {link.name}
                </motion.a>
              ))}
            </div>
          </div>

          {/* Fun Stats */}
          <div>
            <h4 className="text-white font-bold mb-4">Lab Statistics</h4>
            <div className="space-y-2 text-sm">
              <div className="flex justify-between text-gray-400">
                <span>Code Purity:</span>
                <span className="text-bb-green-light">99.1%</span>
              </div>
              <div className="flex justify-between text-gray-400">
                <span>Projects Cooked:</span>
                <span className="text-bb-green-light">20+</span>
              </div>
              <div className="flex justify-between text-gray-400">
                <span>Coffee Consumed:</span>
                <span className="text-bb-green-light">500+ Cups</span>
              </div>
              <div className="flex justify-between text-gray-400">
                <span>Bugs Squashed:</span>
                <span className="text-bb-green-light">Countless</span>
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-green-900 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <motion.p
              className="text-gray-400 text-sm flex items-center gap-2"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
            >
              © {currentYear} Jiten Mahajan. Cooked with
              <motion.span
                animate={{ scale: [1, 1.2, 1] }}
                transition={{ duration: 1, repeat: Infinity }}
              >
                <FaHeart className="text-red-500" />
              </motion.span>
              and lots of ☕
            </motion.p>

            <p className="text-gray-500 text-xs italic">
              "I am the one who codes!"
            </p>
          </div>

          {/* Easter Egg */}
          <motion.div
            className="text-center mt-6"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
          >
            <p className="text-gray-600 text-xs">
              No actual meth was produced in the making of this portfolio.
              <br />
              Only pure, crystalline JavaScript. 💎
            </p>
          </motion.div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
